export default __webpack_public_path__ + "static/banner-new-997751c8b3b0cfced6f5db91f8c84b51.png";